import { render, staticRenderFns } from "./InputVoiceSelector.vue?vue&type=template&id=5ed417f5"
import script from "./InputVoiceSelector.vue?vue&type=script&lang=js"
export * from "./InputVoiceSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports